import { CodeSnippetExecState } from '@devbookhq/sdk'

import cn from 'classnames'

import ExecutionButton from 'components/ExecutionButton'
import Title from 'components/typography/Title'

export interface Props {
  state: CodeSnippetExecState
  stop: () => void
}

function ExampleExecutionScreen({
  state,
  stop,
}: Props) {
  const isHidden = state !== CodeSnippetExecState.Running
  return (
    <div
      className={cn(
        { 'opacity-0': isHidden },
        { 'opacity-1': !isHidden },
        { 'pointer-events-auto': !isHidden },
        { 'pointer-events-none': isHidden },
        'absolute',
        'inset-0',
        'top-[2.5rem]',
        'lg:top-0',
        'h-full',
        'w-full',
        'bg-black/50',
        'z-30',
        'flex',
        'flex-col',
        'space-y-2',
        'items-center',
        'justify-center',
      )}
      // Add the `hidden` attribute so Tailwind doesn't
      // apply spacing to this element.
      hidden={isHidden}
    >
      <Title
        size={Title.size.T2}
        title="Executing code"
      />

      <ExecutionButton
        state={CodeSnippetExecState.Running}
        onRunClick={() => {}}
        onStopClick={stop}
      />
    </div>
  )
}

export default ExampleExecutionScreen
